.row {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 12px 16px;
    border: none;
    border-bottom: 1px solid var(--exo-color-border-secondary);
    width: 100%;
    text-align: left;
    cursor: pointer;
    background: none;
    color: var(--exo-color-font);
    transition: background 0.12s;
}

.row:last-child {
    border-bottom: none;
}

.row:hover {
    background: var(--exo-color-background-secondary);
}

.row:focus-visible {
    outline: 2px solid var(--exo-color-border-tertiary);
    outline-offset: -2px;
}

.iconWrap {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    border: 1px solid var(--exo-color-border-secondary);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.info {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
    min-width: 0;
}

.name {
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
